import 'react/jsx-runtime';
import 'react';
import 'baseui';
import '../../theme/olx-theme/base-theme.js';
import '../../theme/olx-theme/theme.js';
import { styled } from '../../theme/utils.js';
import '../../theme/types.js';
import { tokens } from '../../theme/olx-theme/ds-tokens.js';
import './button.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const StyledContentContainer = styled("span", ({ $theme, $kind }) => __spreadValues({
  display: "inline-flex"
}, $kind === "tertiary" && {
  position: "relative",
  "::after": {
    backgroundColor: "currentColor",
    bottom: `-${$theme.space[4]}`,
    content: '""',
    display: "block",
    height: "1px",
    position: "absolute",
    left: 0,
    transitionDuration: $theme.animation.duration[150],
    transitionTimingFunction: $theme.animation.timingFn.ease,
    width: "100%",
    transform: `scaleY(${parseInt(tokens.borderWidths.medium, 10)})`
  }
}));

export { StyledContentContainer };
